import "../../global.css";
import React, { useState } from "react";

export default function Headers({ userData, onMenuToggle }) {
  const [showLogout, setShowLogout] = useState(false);

  const toggleLogoutDropdown = () => {
    setShowLogout((prev) => !prev);
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.replace("/login");
  };

  return (
    <header className="top-nav">
      {/* Mobile Menu Button */}
      {/* {onMenuToggle && (
        <button
          className="mobile-menu-btn"
          onClick={onMenuToggle}
          aria-label="Toggle Menu"
        >
          <i className="fas fa-bars"></i>
        </button>
      )} */}

      {/* Breadcrumbs / Title */}
      <div className="breadcrumbs" id="breadcrumbs">
        <span>Online Train Order Tracking</span>
      </div>

      {/* Top Actions - User Avatar and Logout */}
      <div className="top-actions" style={{ position: "relative" }}>
        <img
          src="/assets/images/profile.png"
          alt="User Avatar"
          className="user-avatar"
          onClick={toggleLogoutDropdown}
          style={{ cursor: "pointer" }}
        />
        {showLogout && (
          <div className="user-info-dropdown">
            <div style={{ fontWeight: 600, fontSize: "1rem", color: "#333" }}>
              {userData?.name || "User"}
            </div>
            <div style={{ fontSize: "0.95rem", color: "#666" }}>
              {userData?.email || "email@example.com"}
            </div>
            <div
              style={{
                fontSize: "0.92rem",
                color: "#888",
                background: "#f5f5f5",
                borderRadius: "6px",
                padding: "2px 8px",
              }}
            >
              {userData?.role || "User"}
            </div>
            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
